import React, { FunctionComponent } from 'react';
import Style                        from './Button.style';
import { Tooltip }                  from 'antd';
import { Subject }                  from 'rxjs';
import { ButtonType }               from 'antd/lib/button';

type TProps = {
  subject?: Subject<any> | null,
  onClick?: () => unknown,
  type?: ButtonType | 'secondary',
  label?: React.ReactElement | string | null,
  title?: React.ReactElement | string | null,
  htmlType?: 'button' | 'submit' | 'reset',
  className?: string,
  disabled?: boolean,
  danger?: boolean,
  style?: any,
  children?: React.ReactNode,
}

export const Button: FunctionComponent<TProps> = ({
  subject = null,
  onClick = () => {
  },
  type = 'primary',
  label = '',
  title = '',
  htmlType,
  className,
  disabled,
  danger,
  style,
  children
}) => {


  const handleClick = () => {
    if (subject) {
      return subject.next(undefined);
    }
    onClick();
  };

  const renderButton = () => {
    return (
      /* @ts-ignore */
      <Style htmlType={htmlType} type={type}
        className={className}
        disabled={disabled}
        danger={danger}
        style={style}
        title={''}
        onClick={handleClick}
      >
        {children || label}
      </Style>
    );
  };

  if (title) {
    return (
      <Tooltip title={title}>
        {renderButton()}
      </Tooltip>
    );
  }
  return renderButton();

}
